import React from 'react';
import ModalContainer from '../../../../uiToolkit/ModalContainer';
import {microreelsListText} from '../microreelsListText';
import MicroreelLearnersPanel from './MicroreelLearnersPanel';
import styles from './MicroreelLearnersModal.module.css';

interface Props {
  groupTitle: string;
  publishedCourseId: string;
  onClose: () => void;
}

const MicroreelLearnersModal = ({
  groupTitle,
  publishedCourseId,
  onClose,
}: Props) => (
  <ModalContainer onClose={onClose} className={styles.modal}>
    <div className={styles.content}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          {microreelsListText.learnersModalTitle(groupTitle)}
        </h2>
        <p className={styles.subtitle}>
          {microreelsListText.learnersModalSubtitle}
        </p>
      </div>
      <MicroreelLearnersPanel
        publishedCourseId={publishedCourseId}
        onClose={onClose}
      />
    </div>
  </ModalContainer>
);

export default MicroreelLearnersModal;
